import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2DocumentDraftOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M16.509 11.988H6.034v-2h10.475zM6.034 15.995h10.475v-2H6.034zm0 3.96h6.67v-2h-6.67zm16.5 1.663 4.541-4.54-3.229-3.23-3.895 3.895 1.045 1.046 2.588-2.7v2.89l-7.734 8.068-4.445-.11.44-3.917 12.001-12 6.057 6.057-5.955 5.955zm-2.922-1.385-1.075-1.076-4.782 4.782-.119 1.052 1.381.034zM23.445 24h2v6H2V2h18.755L26 7.486V10h-8V4H4v24h19.445zM20 8h3.684l-3.635-3.84z" /></svg>
);
